import { InputSkeleton, TextareaSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} withBreadcrumb />

      <Container>
        <LeftSection>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <TextareaSkeleton className="col-span-12" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
